var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imagebg",style:(_vm.getBackground())},[_c('img',{staticClass:"center",staticStyle:{"width":"100px","hight":"100px"},attrs:{"src":require("../assets/images/logo2.png"),"loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }